import { AbodeAggregateGeoType, PropertyIdentification, RESOListing } from '@aloft/toolkit-shared';

export const getGeoIdForSelectedGeoType = (
  geoType: AbodeAggregateGeoType,
  filterValue?: string,
  propertyIdentification?: PropertyIdentification,
  subjectListingData?: RESOListing
) => {
  switch (geoType) {
    case 'zip':
      return filterValue ?? propertyIdentification?.address.PostalCode?.substring(0, 5) ?? '';
    case 'city':
      return `${propertyIdentification?.address.CityName.toUpperCase()}, ${propertyIdentification?.address.StateCode}`;
    case 'county':
      return subjectListingData?.CountyOrParishFIPS ?? '';
    default:
      throw new Error(`Unknown geo type: ${geoType}`);
  }
}
